import styled from 'styled-components/macro'
import { BaseColor, themeColor, spacing, borderRadius } from '@unbounded/unbounded-components'

export const Container = styled.div`
  background-color: ${themeColor(BaseColor.shade_0)};
  color: ${themeColor(BaseColor.shade_50)};
  padding: ${spacing(1.25)};
  border-radius: ${borderRadius};
`

export const Description = styled.article``

export const SocialContainer = styled.div`
  margin-top: ${spacing(0.75)};
  margin-bottom: ${spacing(-0.25)};
`
